
export const SET_CURRENT_LANG = "SET_CURRENT_LANG"; //Current selected language

export const SET_LOGIN_USER = "SET_LOGIN_USER";
